import {
  ADD_CANVAS,
  ADD_CANVAS_SUCCESS,
  ADD_CANVAS_FAILED,
  FETCH_CANVAS,
  FETCH_CANVAS_SUCCESS,
  FETCH_CANVAS_FAILED,
  EDIT_CANVAS,
  EDIT_CANVAS_SUCCESS,
  EDIT_CANVAS_FAILED,
  DELETE_CANVAS,
  DELETE_CANVAS_SUCCESS,
  DELETE_CANVAS_FAILED,
} from "../store/types";

import { isEmpty } from "../other/Utils";

export const CreateCanvas = (CanvasData) => (dispatch) => (firebase) => {
  const { canvasRef, auth } = firebase;

  try {
    dispatch({
      type: ADD_CANVAS,
      payload: null,
    });

    if (CanvasData) {
      //Check if all the Data is there for the LISTING to be created

      //array to hold all the errors if there are any
      let ErrorArray = [];

      //checking the data

      // if (isEmpty(ListingData?.PropertySize)) {
      //   ErrorArray.push("Please Input a desired in (m^2)")
      // }
      // if (isEmpty(ListingData?.Location)) {
      //   ErrorArray.push("Please Input a Location")
      // }
      // if (isEmpty(ListingData?.OtherInfo)) {
      //   ErrorArray.push("Please Input Extra Infomation")
      // }
      // if (isEmpty(ListingData?.TypeOfBuy)) {
      //   ErrorArray.push("Please Select if you want to lease or purchase")
      // }
      // if (isEmpty(ListingData?.TypeOfBuilding)) {
      //   ErrorArray.push("Please Select the type of building, Commercial or Industrial")
      // }
      // if(ListingData?.Picturearr.length ===0) {
      //     ErrorArray.push("Please Upload pictures as well")
      // }

      if (ErrorArray.length > 0) {
        dispatch({
          type: ADD_CANVAS_FAILED,
          payload: ErrorArray,
        });
      } else {
        CanvasData = {
          ...CanvasData,
          userdetails: {
            id: auth?.currentUser?.uid,
            email: auth?.currentUser?.email,
            mobile: auth?.currentUser?.profile?.mobile,
            Name: auth?.currentUser?.profile?.firstName,
            lastName: auth.currentUser.profile?.lastName,
            profile: auth?.currentUser?.profile?.profile_image
              ? auth.currentUser.profile.profile_image
              : null,
          },
        };

        canvasRef
          .push(CanvasData)
          .then((res) => {
            var id = res.key;
            CanvasData.id = id;

            dispatch({
              type: ADD_CANVAS_SUCCESS,
              payload: CanvasData,
            });
          })
          .catch((error) => {
            dispatch({
              type: ADD_CANVAS_FAILED,
              payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
            });
          });
      }
    }
  } catch (error) {
    dispatch({
      type: ADD_CANVAS_FAILED,
      payload: `Sorry we recieved an error ,\n ${error}`,
    });
  }
};

export const fetchCanvas = () => (dispatch) => (firebase) => {
  const { canvasRef } = firebase;
  try {
    dispatch({
      type: FETCH_CANVAS,
      payload: null,
    });

    canvasRef.on("value", (snapshot) => {
      let canvasHistory = snapshot.val();
      if (canvasHistory) {
        //converting data from database to an array to be used in the app
        let canvasHistoryKeys = Object.keys(canvasHistory);
        let canvasHistoryData = Object.values(canvasHistory);

        for (let index = 0; index < canvasHistoryData.length; index++) {
          //putting the id into the object of all the element of the array
          canvasHistoryData[index] = {
            ...canvasHistoryData[index],
            id: canvasHistoryKeys[index],
          };
        }

        dispatch({
          type: FETCH_CANVAS_SUCCESS,
          payload: canvasHistoryData,
        });
      } else {
        dispatch({
          type: FETCH_CANVAS_FAILED,
          payload: `No data found`,
        });
      }
    });
  } catch (error) {
    dispatch({
      type: FETCH_CANVAS_FAILED,
      payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
    });
  }
};

export const UpdateCanvas = (UpdatedCanvasData) => (dispatch) => (firebase) => {
    //Please send the full LISTING object with the update data and the data that was not updated
    const { singlecanvasRef, auth } = firebase;
    dispatch({
      type: EDIT_CANVAS,
      payload: null,
    });
    try {
      if (UpdatedCanvasData) {
        singlecanvasRef(UpdatedCanvasData.id)
          .set(UpdatedCanvasData)
          .then(() => {
            dispatch({
              type: EDIT_CANVAS_SUCCESS,
              payload: UpdatedCanvasData,
            });
          })
          .catch((error) => {
            dispatch({
              type: EDIT_CANVAS_FAILED,
              payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
            });
          });
      } else {
        dispatch({
          type: EDIT_CANVAS_FAILED,
          payload: "Please double check inputted data",
        });
      }
    } catch (error) {
      dispatch({
        type: EDIT_CANVAS_FAILED,
        payload: error,
      });
    }
  };

export const DeleteCanvas = (deleteCanvasData) => (dispatch) => (firebase) => {
  //all that is required for this is a confirmation that the user wants to delete the LISTING and the id of the LISTING that the user wants to delete
  const { singlecanvasRef } = firebase;

  try {
    dispatch({
      type: DELETE_CANVAS,
      payload: null,
    });

    if (deleteCanvasData.confirmation === true) {
      singlecanvasRef(deleteCanvasData.id)
        .remove()
        .then(() => {
          dispatch({
            type: DELETE_CANVAS_SUCCESS,
            payload: deleteCanvasData.id,
          });
        })
        .catch((error) => {
          dispatch({
            type: DELETE_CANVAS_FAILED,
            payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
          });
        });
    } else {
      dispatch({
        type: DELETE_CANVAS_FAILED,
        payload: `Did not get proper permissions to delete`,
      });
    }
  } catch (error) {
    dispatch({
      type: DELETE_CANVAS_FAILED,
      payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
    });
  }
};
